import { render, staticRenderFns } from "./recursive.vue?vue&type=template&id=6aca314a&"
import script from "./recursive.vue?vue&type=script&lang=js&"
export * from "./recursive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports